import React, { useEffect, useState } from 'react';
import styles from '../../../assets/css/login/login.module.css';
import PropTypes from 'prop-types';
import Login from './Login';
import { LOGIN_TEXT, validateEmail } from '../../../components/common/helpers';
import LoginForm from './LoginForm';
import { useDispatch, useSelector } from 'react-redux';
import { otpLogin, otpStart, setLoading } from '../../../store/ducks/AuthDuck';
import BtnLogin from './BtnLogin';
import axios from 'axios';
import { baseUrl } from '../../../env';
import { useNavigate } from 'react-router-dom';
import AlertCustom from '../../../components/alert/AlertCustom';
import Button from '../../../components/button/Button';
import useModal from '../../../hooks/useModal';

const ViewsLogin = ({ view }) => {
    const [mailNotFound, setMailNotFound] = useState(false);
    const dispatch = useDispatch();
    const [otp, setOtp] = useState('');
    const { error, emailUserLogin } = useSelector(state => state.auth);
    const [email, setEmail] = useState(emailUserLogin);
    const navitation = useNavigate();

    const [modalAlertInfo, closeModalAlertInfo, openModalAlertInfo] =
        useModal();

    const goToCampfire = () => {
        navitation('/join-campfire');
    };

    const onChangeEmail = e => {
        setEmail(e.target.value);

        // Clear error field
        if (email === '') {
            setMailNotFound(false);
        }
    };

    // Validate otp form
    useEffect(() => {
        if (error) {
            setMailNotFound(true);
        }
    }, [error]);

    const handleSendEmail = async e => {
        e.preventDefault();
        console.log('send email', email);
        // Validate the e-mail address entered
        if (!validateEmail(email)) {
            setMailNotFound(true);
            return null;
        }
        setMailNotFound(false);
        try {
            await axios.post(`${baseUrl}/auth/verify`, { email });
            dispatch(otpStart({ email }));
        } catch (error) {
            if (error.response.data.status === 401) {
                openModalAlertInfo();
            }
            console.log('Marcos_Error', error.response);
        }
    };

    const handleLogin = async e => {
        e.preventDefault();

        setMailNotFound(false);
        dispatch(setLoading(true));
        dispatch(otpLogin({ email, otp }));
        dispatch(setLoading(false));
    };

    const VIEWS = {
        1: (
            <Login>
                <div className={styles.login__text}>
                    <div>
                        <p className={styles.font_size_normal}>
                            {LOGIN_TEXT.TEXT_VIEW_1_1}
                        </p>
                        <p className={styles.text_medium}>
                            {LOGIN_TEXT.TEXT_VIEW_1_2}
                        </p>
                    </div>
                    <div className={styles.text_two}>
                        <p>{LOGIN_TEXT.TEXT_VIEW_1_3}</p>
                    </div>
                </div>
                <div className={styles.login__input}>
                    <LoginForm
                        required={true}
                        view={view}
                        email={email}
                        onChangeEmail={onChangeEmail}
                        mailNotFound={mailNotFound}
                        handleSubmit={handleSendEmail}
                        text1={LOGIN_TEXT.TEXT_VIEW_1_FORM_1}>
                        <BtnLogin type="submit">Next</BtnLogin>
                    </LoginForm>
                    <AlertCustom
                        showModal={modalAlertInfo}
                        closeModal={closeModalAlertInfo}
                        title="ERROR:"
                        subtitle="This email is not associated with an organization. Please reach out to your organization to join."
                        typeAlert="info">
                        <Button
                            onClick={closeModalAlertInfo}
                            classs="btnMain"
                            text="Ok"
                        />
                    </AlertCustom>
                </div>
            </Login>
        ),
        2: (
            <Login>
                <div className={styles.login__text}>
                    <div>
                        <p className={styles.font_weight_bold}>
                            {LOGIN_TEXT.TEXT_VIEW_2_1}
                        </p>
                        <p className={styles.font_size_medium}>
                            {LOGIN_TEXT.TEXT_VIEW_2_2}
                            <span className={styles.required}>*</span>
                        </p>
                    </div>
                </div>
                <div className={styles.login__input}>
                    <LoginForm
                        view={view}
                        otp={otp}
                        text1={LOGIN_TEXT.TEXT_VIEW_2_FORM_1}
                        mailNotFound={mailNotFound}
                        handleSubmit={handleLogin}
                        email={emailUserLogin}
                        handleSendEmail={handleSendEmail}
                        onChangeOtp={otp => setOtp(otp)}>
                        <BtnLogin type="submit">Next</BtnLogin>
                    </LoginForm>
                </div>
            </Login>
        ),
        3: (
            <Login>
                <div className={styles.login__text}>
                    <div>
                        <p className={styles.font_weight_bold}>
                            {LOGIN_TEXT.TEXT_VIEW_3_1}
                        </p>
                        <p className={styles.font_size_medium}>
                            {LOGIN_TEXT.TEXT_VIEW_3_2}
                        </p>
                    </div>
                </div>
                <BtnLogin action={goToCampfire}>Go to Campfire</BtnLogin>
            </Login>
        )
    };

    return VIEWS[view];
};

ViewsLogin.propTypes = {
    view: PropTypes.number.isRequired
};

export default ViewsLogin;
